<template>
    <v-container grid-list-sm>
        <v-layout row wrap>
            <v-flex xs12 offset-xs0 sm10 offset-sm1 md8 offset-md2 lg6 offset-lg3 xl4 offset-xl4>
                <v-container grid-list-sm class="pt-0">
                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-layout align-center column fill-height mt-1 mb-3>
                                <img src="../../assets/logo.png" alt="JMP" class="signin-logo" width="100%" style="max-width:300px;" />
                                <!-- <img src="../../assets/logo.png" alt="Natal Gaskets" class="signin-logo" width="100%" style="max-width:500px;" v-if="$portalId === 2" /> -->
                                <!-- <h1 class="font-weight-light">National Business Portal</h1> -->
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 elevation-2 pa-5 white>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <h1 class="title font-weight-light mb-3">Sign In</h1>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        v-model="form.email"
                                        :rules="[rules.required]"
                                        label="Email or Username"
                                        outline
                                        append-icon="email"
                                        @keyup.native="goToPass"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field ref="passwordTxt"
                                        v-model="form.password"
                                        :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                        :rules="[rules.required, rules.min]"
                                        :type="showPassword ? 'text' : 'password'"
                                        name="input-10-1"
                                        label="Password"
                                        hint="At least 8 characters"
                                        outline
                                        counter
                                        @keyup.native="onKey"
                                        @click:append="showPassword = !showPassword"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-btn color="primary" :loading="isBusy" class="ml-0" @click="onSignIn">Sign In</v-btn>
                                    <v-btn href="https://www.jmpbiz.co.za" flat class="el-float-right mr-0" v-if="$portalId === 2">JMP Portal</v-btn>
                                    <v-btn href="https://www.natalgaskets.co.za" flat class="el-float-right mr-0" v-if="$portalId === 1">Natal Gaskets</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12>
                            <v-layout column fill-height mt-1>
                                <div style="font-size: 8pt; opacity: 0.5; padding: 5px;">V 1.1.1995</div>
                                <v-alert v-show="loginError" :value="true" type="error" class="el-m-b-5">Sign In Failed: Sign in attempt failed. Please revise your credentials and try again.</v-alert>
                                <v-alert v-show="noCompany" :value="true" type="error">Your account has not been linked to a company. Please contact support for assistance.</v-alert>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>
        <v-dialog v-model="showDialog" :fullscreen="$vuetify.breakpoint.xsOnly" persistent max-width="900px">
            <v-card>
                <v-card-title>
                    <span class="headline">Select Company</span>
                </v-card-title>
                <v-card-text class="pt-0">
                    <v-container grid-list-sm class="pa-0">
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-divider></v-divider>
                                <v-data-table :headers="headers" :items="tableData" hide-actions hide-headers class="table-even-odd">
                                    <template slot="items" slot-scope="props">
                                        <tr @click="onSelectCompany(props.item)">
                                            <td class="f-l">{{ props.item.Name }}</td>
                                        </tr>
                                    </template>
                                    <template slot="no-data">
                                        <v-subheader>No records.</v-subheader>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="pa-3">
                    <v-btn color="primary" @click="showDialog=false">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
export default {
    name: 'SignIn',
    data() {
        return {
            title: 'Sign In',
            isBusy: false,
            viewPass: false,
            loginError: false,
            noCompany: false,
            ViewCompany: {},
            form: {
                email: '',
                password: ''
            },
            showPassword: false,
            showDialog: false,
            tableData: [],
            headers: [
                { text: 'Company Name', value: 'Name', align: 'left' }
            ],
            rules: {
                required: value => !!value || 'Required.',
                min: v => v.length >= 8 || 'Min 8 characters',
                emailMatch: () => ('The email and password you entered don\'t match')
            }
        };
    },
    mounted() {
        this.ViewCompany = this.$ls.get('ViewCompany', {});
    },
    validations() {
        //
    },
    methods: {
        goToPass(evt) {
            if (evt.key === 'Enter') this.$refs.passwordTxt.focus();
        },
        onKey(evt) {
            if (evt.key === 'Enter') this.onSignIn();
        },
        onSignIn() {
            this.loginError = false;
            this.noCompany = false;
            this.isBusy = true;
            this.$http
                .post('/signin', this.form)
                .then(response => {
                    if (response.data.s) {
                        this.isBusy = false;
                        const d = response.data.d;
                        if (!d.user.C.length) {
                            this.noCompany = true;
                            return;
                        }
                        this.d = d;
                        if (d.user.C.length > 1) {
                            let tmp;
                            if (this.ViewCompany._id) {
                                tmp = d.user.C.find(o => o._id === this.ViewCompany._id);
                            }
                            if (tmp) {
                                this.ViewCompany = tmp;
                                this.setOk();
                            }
                            else {
                                this.tableData = d.user.C;
                                this.showDialog = true;
                            }
                        }
                        else {
                            this.ViewCompany = d.user.C[0];
                            this.setOk();
                        }
                    }
                    else {
                        this.loginError = true;
                        this.isBusy = false;
                        this.$alert({ type: 'error', title: 'Sign In Failed', message: 'Sign in attempt failed. Please revise your credentials and try again.' });
                    }
                })
                .catch(err => {
                    this.loginError = true;
                    this.isBusy = false;
                    console.error(err);
                    this.$alert({ type: 'error', title: 'Sign In Failed', message: 'Sign in attempt failed. Please revise your credentials and try again.' });
                });
        },
        onSelectCompany(company) {
            this.ViewCompany = company;
            this.$ls.set('ViewCompany', this.ViewCompany);
            this.setOk();
        },
        setOk() {
            const d = this.d;
            d.user.DN = `${d.user.FN || ''} ${d.user.LN || ''}`.trim(); // Display name.
            this.$ls.set('SignedIn', true); // Store authentication state.
            this.$ls.set('User', d.user); // Store the user.
            this.$ls.set('Token', d.token);
            this.$ls.set('LastDt', new Date());
            this.$http.defaults.headers.common.Authorization = d.token; // Set the token on all request headers.
            this.$ls.set('ViewCompany', this.ViewCompany); // Set the selected company.
            this.$root.$emit('SignedIn', true);
            // this.$router.push({ path: 'Dashboard' });
            if (d.user.DN === 'MSSL Admin') this.$router.push({ path: 'MSSL' });
            else this.$router.push({ path: 'Dashboard' });
        }
    }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/User/SignIn.vue